import { BASE_URL, ENDPOINTS, get, post } from '@/api/mainApi';
import Vue from 'vue';
import { Snackbar } from '@/interfaces/presentation/snackbar';
import { AxiosError } from 'axios';
import { BusinessSettings } from '@/interfaces/business/businessSettings';
import { PersonalDataProcessingAgreementType } from '@/enums/personalDataAgreementType';

export class LifeArchiveRepository {
  constructor(private vueInstance: Vue) {
  }

  public getLifeArchiveDocumentUrl(depotId: number): String {
      return `${BASE_URL}/api/${ENDPOINTS.LIFE_ARCHIVE}/${depotId}`
  }

  public async getLifeArchiveDocumentFile(depotId: number): Promise<File> {
    try {
      return await get(`${ENDPOINTS.LIFE_ARCHIVE}/${depotId}`);
    } catch (error) {
      this.handleError(error, `Misslyckades med att hämta livsarkivsdokument: ${error.data.msg || 'Okänt fel'}`);
      return Promise.reject(error);
    }
  }

  private setSnackbar(message: string, color: 'error' | 'success') {
    const snackbar: Snackbar = {
      active: true,
      color: color,
      text: message,
      timeout: 10000,
      action: null,
    };
    this.vueInstance.$store.commit('setSnackbar', snackbar);
  }

  private handleError(error: AxiosError, errorMessage: string) {
    if (error.response?.status === 403) {
      this.setSnackbar('Du saknar rättigheter för att utföra den begärda handlingen', 'error');
    } else {
      this.setSnackbar(errorMessage, 'error');
    }
  }
}
